<div style="height: calc(100vh - 127px); margin: -20px;">
  @if (!collections?.length) {
    <!-- Initial message -->
    <div class="card-report" style="text-align: center; padding: 40px; margin-top: 20px;">
      <div style="color: #666; font-size: 16px;">
        <div style="background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
          <ul style="list-style: none; padding: 0; margin: 0; text-align: left;">
            <li style="margin: 12px 0; display: flex; align-items: center;">
              <span style="background-color: #366092; color: white; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-right: 12px; font-size: 12px; font-weight: bold;">1</span>
              <span>📅 Select the date range in the filter above</span>
            </li>
            <li style="margin: 12px 0; display: flex; align-items: center;">
              <span style="background-color: #366092; color: white; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-right: 12px; font-size: 12px; font-weight: bold;">2</span>
              <span>👥 Select one or more clients from the "Clients" button</span>
            </li>
            <li style="margin: 12px 0; display: flex; align-items: center;">
              <span style="background-color: #28a745; color: white; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-right: 12px; font-size: 12px; font-weight: bold;">✓</span>
              <span>🔍 Data will load automatically</span>
            </li>
          </ul>
        </div>
        <div style="margin: 20px 0;">
          <app-custom-button class="mx-auto" style="width: fit-content;" (buttonClick)="openExportModal()">
            Filter Clients and Date
          </app-custom-button>
        </div>
        <p style="margin-top: 15px; font-size: 14px; color: #888; font-style: italic;">Both filters (dates and clients) are required to generate the report.</p>
      </div>
    </div>
  } @else {
    <app-document-viewer 
      [loadingData]="loading" 
      [filterByDate]="true" 
      orientation="landscape" 
      [onDownload]="downloadReport.bind(this)" 
      (filterChange)="onFilterChange($event)"
      >
      
      <!-- Toolbar Filter Button -->
      <div header>
        <app-custom-button (buttonClick)="openExportModal()" extraClasses="btn-sm">
          Change Filters
        </app-custom-button>
      </div>
      
      <!-- Report Header -->
      <div class="card-report" style="margin-bottom: 20px; text-align: center;">
        <h1 style="margin: 0; font-size: 24px; font-weight: bold;">UCO CONSOLIDATED REPORT</h1>
        <p style="margin: 5px 0; font-size: 14px; color: #666;">Date Range: {{dateRange}}</p>
        <div style="display: flex; justify-content: space-between; margin-top: 15px; font-size: 12px;">
           <span><strong>Clients</strong> {{payload.clients?.length}}</span>
          <span><strong>Total Collected</strong> {{totalCollected | number : '1.2-2'}}</span>
          <span><strong>Total Clean Oil</strong> {{totalCleaned | number : '1.2-2'}}</span>
          <span><strong>Total Cost</strong> {{totalCost | currency}}</span>
        </div>
      </div>

      <!-- Main Data Table -->
      <div class="table-container card-report">
        <table>
          <thead>
            <tr>
              <th rowspan="2" style="vertical-align: middle;">Client</th>
              <th rowspan="2" style="vertical-align: middle;">Address</th>
              <th rowspan="2" style="vertical-align: middle; text-align: center;">Cost</th>
              <th rowspan="2" style="vertical-align: middle; text-align: center;">Tank</th>
              <th rowspan="2" style="vertical-align: middle;">Month</th>
              <th rowspan="2" style="vertical-align: middle; text-align: center;">Day</th>
              <th colspan="1" style="vertical-align: middle; background-color: #366092; text-align: center;">Collected</th>
              <th colspan="1" style="vertical-align: middle; background-color: #366092; text-align: center;">Clean Oil</th>
              <th rowspan="2" style="vertical-align: middle; background-color: #548135; text-align: center;">Total Cost</th>
            </tr>
          </thead>
          <tbody>
              <tr *ngFor="let item of collections; let i = index">
                <td class="fw-medium" [style]="item.client ? 'font-weight: 500; background-color: #f9f9f9;' : ''">{{ item.client }}</td>
                <td class="fw-medium" [style]="item.client ? 'font-weight: 500; background-color: #f9f9f9;' : ''">{{ item.address }}</td>
                <td class="text-center fw-medium" [style]="item.client ? 'font-weight: 500; background-color: #f9f9f9;' : ''">{{ item.cost | currency }}</td>
                <td class="text-center fw-medium" [style]="item.client ? 'font-weight: 500; background-color: #f9f9f9;' : ''">{{ item.tank }}</td>
                <td [style]="item.month ? 'font-weight: 500; background-color: #f9f9f9;' : ''">{{ item.month }}</td>
                <td class="text-center" [style]="item.month ? 'font-weight: 500; background-color: #f9f9f9;' : ''">{{ item.day }}</td>
                <td class="text-center" [style]="item.month ? 'background-color: #b0d0ed; font-weight: 500;': item.isTotalRow ? 'font-weight: 500; background-color: #366092; color: #ffffff;' : ''">{{ item.collected }}</td>
                <td class="text-center" [style]="item.month ? 'background-color: #b0d0ed; font-weight: 500;': item.isTotalRow ? 'font-weight: 500; background-color: #366092; color: #ffffff;' : ''">{{ item.cleaned }}</td>
                <td class="text-center" [style]="item.month ? 'background-color: #cff2b7; font-weight: 500;': item.isTotalRow ? 'font-weight: 500; background-color: #366092; color: #ffffff;' : ''">{{ item.totalCost | currency }}</td>
              </tr>
          </tbody>
        </table>
      </div>
    </app-document-viewer>
  }
</div>